<template>
  <div>
    <v-row class="noYPadding">
      <v-col
        class="noYPadding"
        cols="12"
        sm="3"
      >
        <VTextField
          v-model="mutableValues.streetNumber"
          outlined
          :label="$t('forms.labels.streetNumber')"
          :rules="{ max: 10, required: true, }"

          data-cy="addContact-streetNumber"
          @input="$emit('change', mutableValues)"
        />
      </v-col>
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="mutableValues.address"
          outlined
          readonly
          :label="$t('forms.labels.address')"
          :rules="{ max: 200, required: true, }"

          @input="$emit('change', mutableValues)"
        />
      </v-col>
      <v-col
        class="noYPadding"
        cols="12"
        sm="3"
      >
        <VTextField
          v-model="mutableValues.appartmentNumber"
          outlined
          :label="$t('forms.labels.appartmentNumber')"
          :rules="{ max: 10, }"

          @input="$emit('change', mutableValues)"
        />
      </v-col>
    </v-row>

    <v-row class="noYPadding">
      <v-col
        class="noYPadding"
        cols="12"
        sm="4"
      >
        <VAutocomplete
          v-if="!adressWithAutocomplete"
          v-model="mutableValues.country"
          outlined
          clearable
          readonly
          itemValue="code"

          :items="countries"
          :label="$t('forms.labels.country')"
          :loading="isLoadingCountries"
          :rules="{ required: true, }"
          data-cy="country"
          @change="onChangeCountry"
        />
        <VTextField
          v-if="adressWithAutocomplete"
          v-model="mutableValues.country"
          outlined
          readonly
          itemValue="code"

          :label="$t('forms.labels.country')"
          :rules="{ required: true, }"
          data-cy="country"
          @change="onChangeCountry"
        />
      </v-col>
      <v-col
        class="noYPadding"
        cols="12"
        sm="4"
      >
        <VAutocomplete
          v-if="!adressWithAutocomplete"
          v-model="mutableValues.province"
          outlined
          clearable
          readonly
          itemValue="code"

          :items="provinces"
          :label="$t('forms.labels.province')"
          :loading="isLoadingProvinces"
          :rules="{ required: true, }"
          data-cy="province"
          @change="onChangeProvince"
        />
        <VTextField
          v-if="adressWithAutocomplete"
          v-model="mutableValues.province"
          readonly
          outlined
          itemValue="code"

          :label="$t('forms.labels.province')"
          :rules="{ required: true, }"
          data-cy="province"
          @change="onChangeProvince"
        />
      </v-col>
      <v-col
        class="noYPadding"
        cols="12"
        sm="4"
      >
        <VAutocomplete
          v-if="!adressWithAutocomplete"
          v-model="mutableValues.city"
          outlined
          clearable
          readonly
          itemValue="name"
          :items="cities"
          :label="$t('forms.labels.city')"
          :loading="isLoadingCities"
          :rules="{ required: true, }"
          data-cy="city"
          @change="onChangeCity"
        />


        <VTextField
          v-if="adressWithAutocomplete"
          v-model="mutableValues.city"
          readonly
          outlined
          itemValue="name"
          :label="$t('forms.labels.city')"
          :rules="{ required: true, }"
          data-cy="city"
          @change="onChangeCity"
        />
      </v-col>
    </v-row>
    <v-row class="noYPadding">
      <v-col
        class="noYPadding"
        cols="12"
        sm="4"
      >
        <VTextField
          v-model="mutableValues.postalCode"
          outlined
          :readonly="false"
          :label="$t('forms.labels.postalCode')"
          :rules="{ max: 20, required: true, }"

          @input="$emit('change', mutableValues)"
        />
      </v-col>

      <v-col
        class="noYPadding"
        cols="12"
        sm="3"
      >
        <VTextField
          v-if="timezoneRequired"
          v-model="mutableValues.tz"
          outlined
          readonly
          :label="$t('forms.labels.timezone')"
          :rules="{ max: 100, required: true }"

          @input="$emit('change', mutableValues)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';

export default {
    components: {
        VAutocomplete,
        VTextField,
    },
    props: {
        details: {
            type: Object,
            default: () => ({}),
        },
        isEditable: {
            type: Boolean,
            default: true,
        },
        adressWithAutocomplete: {
            type: Boolean,
            default: false,
        },
        timezoneRequired: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            cities: [],
            countries: [],
            isLoadingCities: false,
            isLoadingCountries: false,
            isLoadingProvinces: false,
            mutableValues: {},
            provinces: [],
        };
    },

    watch: {
        details: {
            async handler() {
                await this.init();
            },
            immediate: true,
        },
    },
    async created() {
        if (!this.adressWithAutocomplete) await this.loadCountries();
    },
    methods: {
        async init() {
            this.mutableValues = { ...this.details };

            // Try to load if we have data already
            const { country, province } = this.mutableValues;

            if (!isEmpty(country)) {
                await this.loadProvinces(country);
            }

            if (!isEmpty(province)) {
                if (!this.adressWithAutocomplete) await this.loadCities(country, province);
            }
        },

        /**
         * @param {String} country
         * @return {Promise}
         */
        async onChangeCountry(country) {
            this.resetProvince();
            this.resetCity();
            await this.loadProvinces(country);
            if (!this.mutableValues.country) {
                this.mutableValues.country = '';
            }
            this.$emit('change', this.mutableValues);
        },

        /**
         * @param {String} province
         * @return {Promise}
         */
        async onChangeProvince(province) {
            this.resetCity();
            if (!this.adressWithAutocomplete) await this.loadCities(this.mutableValues.country, province);
            if (!this.mutableValues.province) {
                this.mutableValues.province = '';
            }
            this.$emit('change', this.mutableValues);
        },

        onChangeCity() {
            if (!this.mutableValues.city) {
                this.mutableValues.city = '';
            }
            this.$emit('change', this.mutableValues);
        },

        /**
         * Fetch list of countries from API
         *
         * @return {Promise}
         */
        async loadCountries() {
            this.isLoadingCountries = true;
            const { data } = await this.$rq.getCountries('all');
            this.countries = data.map(({ code, name }) => ({ code, name }));
            this.isLoadingCountries = false;
        },

        /**
         * Fetch list of states from API
         *
         * @param {String} country - code
         * @return {Promise}
         */
        async loadProvinces(country) {
            if (!country) {
                return;
            }
            this.isLoadingProvinces = true;
            const { data } = await this.$rq.getStates(country);
            if (data) {
                this.provinces = data.map(({ code, name }) => ({ code, name }));
            }
            this.isLoadingProvinces = false;
        },

        /**
         * Fetch list of cities from API
         *
         * @param {String} country - code
         * @param {String} province - code
         * @return {Promise}
         */
        async loadCities(country, province) {
            if (!country || !province) {
                return;
            }

            this.isLoadingProvinces = true;
            const { data } = await this.$rq.getCities(country, province);
            this.cities = data.map(({ name }) => ({ name }));
            this.checkCities();
            this.isLoadingProvinces = false;
        },

        checkCities() {
            if (!this.mutableValues.city) {
                return;
            }

            const cities = this.cities.map(city => city.name);
            const hasCity = cities.includes(this.mutableValues.city);

            if (!hasCity) {
                this.$toasted.global.toast_error({
                    message: this.$t('msg.cityMissing', { city: this.mutableValues.city }),
                });
            }
        },

        /**
         * Reset province value and choices
         */
        resetProvince() {
            this.mutableValues.province = null;
            this.provinces = [];
        },

        /**
         * Reset city value and choices
         */
        resetCity() {
            this.mutableValues.city = null;
            this.cities = [];
        },
    },
};
</script>
<style lang="scss" scoped>
    .noYPadding{
        padding: 0 6px;
    }
</style>
